import { memo } from 'react';

import { ShareDesignImageButton } from '~/components/ShareModal/components/ShareDesignImageButton';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/** Custom-logo picker (share-link `customLogo` write), bound to the design context. */
export const CreateShowcaseDesignLogoButton = memo(() => {
  const {
    brandingDisabled,
    brandCustomizationEnabled,
    handleClearLogo,
    handleSelectLogo,
    hasCustomLogo,
    logoBrandOptions,
    logoSrc,
    selectedLogoBrandOptionId,
  } = useCreateShowcaseDesign();

  return (
    <ShareDesignImageButton
      data-testid="CREATE_COLLECTION_LINK_DESIGN_LOGO_ROW"
      disabled={brandingDisabled}
      emptyLabel="Choose logo"
      hasValue={hasCustomLogo}
      imageSrc={logoSrc}
      onClear={handleClearLogo}
      onSelect={handleSelectLogo}
      options={logoBrandOptions}
      selectedOptionId={selectedLogoBrandOptionId}
      selectModalConfirmLabel="Use as logo"
      selectModalTitle="Select a logo"
      selectTestId="CREATE_COLLECTION_LINK_DESIGN_LOGO_SELECT"
      showUpsell={!brandCustomizationEnabled}
    />
  );
});

CreateShowcaseDesignLogoButton.displayName = 'CreateShowcaseDesignLogoButton';
